import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import Diploma from '../Diploma'
import CourseBCA from '../CourseBCA'

export default function LayoutCourseBCA() {
    return (
        <div>
            <Header />
            <CourseBCA />
            <Footer />
        </div>
    )
}
